import {
  Eligibility
} from '../models';

export const mapEligibility = (result) => {

  return new Eligibility(result).mapToStandard();
};